/**
 * The last few errors the app showed, so Aya can explain what just went
 * wrong without asking the user to copy it. Kept in memory only, for ten
 * minutes; just the status, the API path and the server's message.
 */

export interface RecentError {
  status: number | null
  path: string
  message: string
  at: string
}

const KEEP = 5
const MAX_AGE_MS = 10 * 60 * 1000
let errors: RecentError[] = []

function messageOf(data: unknown): string {
  if (!data) return ''
  if (typeof data === 'string') return data.slice(0, 300)
  const detail = (data as { detail?: unknown }).detail
  if (typeof detail === 'string') return detail.slice(0, 300)
  if (Array.isArray(detail)) {
    return detail
      .map((d) => (d && typeof d === 'object' && 'msg' in d ? String((d as { msg: unknown }).msg) : ''))
      .filter(Boolean)
      .join('; ')
      .slice(0, 300)
  }
  return ''
}

export function recordError(status: number | null | undefined, url: string | undefined, data?: unknown, fallback?: string) {
  if (status === 401) return // the session expired: handled by logging in again
  const path = (url || '').split('?')[0].replace(/^https?:\/\/[^/]+/, '').slice(0, 200)
  errors = [...errors, { status: status ?? null, path, message: messageOf(data) || (fallback || '').slice(0, 300), at: new Date().toISOString() }].slice(-KEEP)
}

export function recentErrors(): RecentError[] {
  const since = Date.now() - MAX_AGE_MS
  errors = errors.filter((e) => Date.parse(e.at) >= since)
  return errors.slice(-3)
}

export function clearErrors() {
  errors = []
}
